import axios from '@/api'

export default {
  getAll() {
    return axios.get('/getAllUser') 
  },
  get(id) {
    return axios.get(`/users/${id}`) 
  },
  getCeoUsers() {
    return axios.get('/Financial/incomes/ceo-users') 
  }
}
